import clsx from "clsx";
import React, { useCallback, useMemo } from "react";
import { MdOutlinePushPin, MdPushPin } from "react-icons/md";
import { ICON_SIZES } from "src/helpers/constants";
import Button from "../Button/Button";
import useMobile from "src/hooks/useMobile";

const TableHeaderTogglePinned: React.FC = (props: any) => {
  const { isMobile } = useMobile();
  const columnState = useMemo(() => {
    return props.api?.getColumnState?.();
  }, [props]);

  const isPinned = useMemo(() => {
    return columnState?.find?.(
      (col: any) => col.colId === props.column.getColId()
    )?.pinned;
  }, [columnState, props]);

  const togglePinned = useCallback(
    (e: any) => {
      e?.stopPropagation?.();

      if (!props.api) return;
      props?.innerHeaderComponentParams?.onToggle?.(!isPinned);

      props.api.applyColumnState({
        state: [
          {
            colId: props.column.getColId(),
            pinned: isPinned ? null : "left",
          },
        ],
        applyOrder: false,
      });
    },
    [props, isPinned]
  );

  return (
    <div
      className={clsx(["inline-flex", "items-center", "gap-1"])}
      onTouchStart={(e: any) => {
        e?.stopPropagation?.();
      }}
    >
      <Button
        animate={false}
        icon={
          isPinned ? (
            <MdPushPin
              size={isMobile ? ICON_SIZES.XS : ICON_SIZES.XS}
              className="!text-red-500 dark:!text-purple-400"
            />
          ) : (
            <MdOutlinePushPin
              size={isMobile ? ICON_SIZES.XS : ICON_SIZES.XS}
              className="text-current"
            />
          )
        }
        onClick={togglePinned}
        className={clsx([
          "!bg-transparent",
          "!border-0",
          "!shadow-none",
          "!w-[40px]",
          "!min-w-[40px]",
          "!max-w-[40px]",
          "!h-[40px]",
          "!min-h-[40px]",
          "!max-h-[40px]",
          "!p-0",
          "hover:!opacity-50",
          "pointer-events-auto",
        ])}
      />
      <span>{props.displayName}</span>
    </div>
  );
};

export default React.memo(TableHeaderTogglePinned);
